import requests from './requests';

export default {
    get(id) {
        return requests
            .get(`/trainer/trainer_apply/${id}`)
            .then(resp => resp.data);
    },
    getCoach(id) {
        return requests
            .get(`/trainer/trainer_apply/${id}/coach`)
            .then(resp => resp.data);
    },
    search(phone) {
        return requests
            .post('/trainer/trainer_apply/search', { phone })
            .then(resp => resp.data);
    },
    bind(phone, message) {
        return requests
            .post('/trainer/trainer_apply/bind', { phone, message })
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/trainer_apply.js